var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var PushNotificationsRepository_1;
import { PushNotificationAction } from '../../../Domain/DTOs/PushNotifications/PushNotificationDTO';
import { Observable } from '../../Observable/Observable';
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { IStorageDataSourceType } from '../../DataSource/StorageDataSource/IStorageDataSource';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { CoreConstants } from '../../../CoreConfig';
let PushNotificationsRepository = PushNotificationsRepository_1 = class PushNotificationsRepository {
    constructor(apiDataSource, storageDataSource) {
        this.apiDataSource = apiDataSource;
        this.storageDataSource = storageDataSource;
        this.pushNotifications = new Observable([]);
        this.pushNotification = new Observable(null);
    }
    setLastOpenNotification(id, date) {
        return this.getLastOpenNotification()
            .then(value => {
            const update = { id, date };
            if (!(value === null || value === void 0 ? void 0 : value.date)) {
                return this.storageDataSource.set(PushNotificationsRepository_1.notification_key, update);
            }
            if (value.date > update.date) {
                return value;
            }
            return this.storageDataSource.set(PushNotificationsRepository_1.notification_key, update);
        });
    }
    getLastOpenNotification() {
        return this.storageDataSource.get(PushNotificationsRepository_1.notification_key);
    }
    disablePushNotifications() {
        return Promise.resolve();
    }
    setupChannels() { }
    getLastPushNotification() {
        if (this.pushNotifications.value.length > 0) {
            return Promise.resolve(null);
        }
        return this.getLastOpenNotification()
            .then(value => {
            const default_date = Date.create();
            default_date.setHours(0, 0, 0);
            const params = {
                path: 'push_notifications',
                params: {
                    created_at_gt: (value === null || value === void 0 ? void 0 : value.date) || default_date.getUnix()
                }
            };
            return this.apiDataSource.get(params).then(({ data }) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                if (!Array.isArray(data) || data.length <= 0) {
                    return null;
                }
                const date = Date.create().getUnix();
                const last_notification = data.sort((a, b) => (a.created_at || 0) - (b.created_at || 0)).findLast(notification => {
                    var _a;
                    if (notification.id == (value === null || value === void 0 ? void 0 : value.id) ||
                        notification.status === CoreConstants.push_notification_status.seen ||
                        notification.action === PushNotificationAction.navigate_to_deep_link ||
                        (((_a = notification.payload) === null || _a === void 0 ? void 0 : _a.valid_to) && date > notification.payload.valid_to)) {
                        return false;
                    }
                    return true;
                });
                if (!last_notification) {
                    return null;
                }
                const notification = {
                    id: last_notification.id,
                    status: last_notification.status,
                    action: last_notification.action || PushNotificationAction.navigate_to_notification,
                    title: (_b = (_a = last_notification.payload) === null || _a === void 0 ? void 0 : _a.popup) === null || _b === void 0 ? void 0 : _b.title,
                    description: (_d = (_c = last_notification.payload) === null || _c === void 0 ? void 0 : _c.popup) === null || _d === void 0 ? void 0 : _d.description,
                    image_url: (_f = (_e = last_notification.payload) === null || _e === void 0 ? void 0 : _e.popup) === null || _f === void 0 ? void 0 : _f.image_url,
                    cta_title: (_j = (_h = (_g = last_notification.payload) === null || _g === void 0 ? void 0 : _g.popup) === null || _h === void 0 ? void 0 : _h.cta_button) === null || _j === void 0 ? void 0 : _j.title,
                    deep_link: (_m = (_l = (_k = last_notification.payload) === null || _k === void 0 ? void 0 : _k.popup) === null || _l === void 0 ? void 0 : _l.cta_button) === null || _m === void 0 ? void 0 : _m.deep_link,
                    valid_to: (_o = last_notification.payload) === null || _o === void 0 ? void 0 : _o.valid_to,
                    created_at: last_notification.created_at
                };
                this.pushNotifications.next([...this.pushNotifications.value, notification]);
                return notification;
            });
        });
    }
    setNotificationStatusToSeen(id) {
        return this.apiDataSource.post({ path: `push_notifications/${id}`, data: { status: CoreConstants.push_notification_status.seen } });
    }
    getIsSupportedPushNotifications() {
        return false;
    }
    setNotificationChannel() {
        return Promise.resolve(null);
    }
    getHasPermissions() {
        return Promise.resolve(false);
    }
    requestPermissions() {
        return Promise.resolve(false);
    }
    getPushToken() {
        return Promise.resolve('');
    }
    getPushNotifications() {
        return Promise.resolve(this.pushNotifications);
    }
    getPushNotification(id) {
        var _a;
        const notification = this.pushNotifications.value.find(x => x.id == id);
        if (notification) {
            notification.created_at && this.setLastOpenNotification(notification.id, notification.created_at);
            if (notification.status !== CoreConstants.push_notification_status.seen) {
                this.setNotificationStatusToSeen(notification.id).catch(console.warn);
            }
            return Promise.resolve(this.pushNotification.next(notification));
        }
        if (((_a = this.pushNotification.value) === null || _a === void 0 ? void 0 : _a.id) === id) {
            this.pushNotification.value.created_at && this.setLastOpenNotification(this.pushNotification.value.id, this.pushNotification.value.created_at);
            if (this.pushNotification.value.status !== CoreConstants.push_notification_status.seen) {
                this.setNotificationStatusToSeen(this.pushNotification.value.id).catch(console.warn);
            }
            return Promise.resolve(this.pushNotification);
        }
        const params = {
            path: `push_notifications/${id}`,
        };
        return this.apiDataSource.get(params)
            .then(({ data }) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            const notification = data === null || data === void 0 ? void 0 : data[0];
            this.setLastOpenNotification(notification.id, notification.created_at);
            this.setNotificationStatusToSeen(notification.id).catch(console.warn);
            return this.pushNotification.next({
                id: notification.id,
                status: notification.status,
                action: notification.action || PushNotificationAction.navigate_to_notification,
                title: (_b = (_a = notification.payload) === null || _a === void 0 ? void 0 : _a.popup) === null || _b === void 0 ? void 0 : _b.title,
                description: (_d = (_c = notification.payload) === null || _c === void 0 ? void 0 : _c.popup) === null || _d === void 0 ? void 0 : _d.description,
                image_url: (_f = (_e = notification.payload) === null || _e === void 0 ? void 0 : _e.popup) === null || _f === void 0 ? void 0 : _f.image_url,
                cta_title: (_j = (_h = (_g = notification.payload) === null || _g === void 0 ? void 0 : _g.popup) === null || _h === void 0 ? void 0 : _h.cta_button) === null || _j === void 0 ? void 0 : _j.title,
                deep_link: (_m = (_l = (_k = notification.payload) === null || _k === void 0 ? void 0 : _k.popup) === null || _l === void 0 ? void 0 : _l.cta_button) === null || _m === void 0 ? void 0 : _m.deep_link,
                valid_to: (_o = notification.payload) === null || _o === void 0 ? void 0 : _o.valid_to,
                created_at: notification.created_at
            });
        });
    }
    deletePushNotification(id) {
        this.pushNotifications.next(this.pushNotifications.value.filter(x => x.id !== id));
        return Promise.resolve(this.pushNotifications);
    }
    setPushNotificationMiddleware(fn) { }
};
PushNotificationsRepository.notification_key = 'last_notification_id';
PushNotificationsRepository = PushNotificationsRepository_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IAPIHTTPDataSourceType)),
    __param(1, inject(IStorageDataSourceType)),
    __metadata("design:paramtypes", [Object, Object])
], PushNotificationsRepository);
export { PushNotificationsRepository };
